export type TNetworkErrorKind = 'network' | 'timeout'

const NETWORK_ERROR_MESSAGES = [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'Load failed',
]

export const getNetworkErrorKind = (error: unknown): TNetworkErrorKind | null => {
    if (error instanceof Error && error.name === 'TimeoutError') {
        return 'timeout'
    }

    if (error instanceof TypeError && NETWORK_ERROR_MESSAGES.includes(error.message)) {
        return 'network'
    }

    return null
}
